export default "__VITE_ASSET__B4BYIf7t__"